import moment from 'moment';
import React from 'react';
import Poster from './Poster.jsx';
import Settings from './Settings.jsx';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: {
        birthday: '1989-10-05',
        maxAge: 90,
        name: 'David',
      },
    };
  }

  render() {
    let {
      settings,
    } = this.state;

    return (
      <div>
        <Poster
          birthday={moment(settings.birthday).isValid() ? settings.birthday : moment()}
          maxAge={settings.maxAge}
          now={moment()}
          name={settings.name}
        />
      </div>
    );
  }
}

export default App;
